import { useParams, Navigate } from 'react-router-dom';
import JobDetail from './JobDetail';
import SlugPage from './SlugPage';
import data from '../seo/landingData';

// Old location URLs (/jobs/bangalore) point to the curated city pages (/jobs-in-bangalore)
// so each city has one main page. Add any other spelling your backend uses.
const CITY_ALIASES = { bengaluru: 'bangalore', hubballi: 'hubli' };
const CITY_SLUGS = new Set(data.CITIES.map((c) => c.slug));

export default function JobOrLocation() {
  const { id } = useParams();

  if (/^[0-9]+$/.test(id)) return <JobDetail />;

  const citySlug = CITY_ALIASES[id] || id;
  if (CITY_SLUGS.has(citySlug)) return <Navigate to={`/jobs-in-${citySlug}`} replace />;

  return <SlugPage />;
}